import { c as _c } from "react/compiler-runtime";
import { TabsPropertiesType } from "@website/ui/tabs/tabs.types";
import omit from "lodash-es/omit";
import { useEffect, useState } from "react";
export const useTab = properties => {
  const $ = _c(21);
  const {
    defaultTab,
    onChange,
    tabs,
    color,
    iconPosition,
    variant,
    size,
    behavior,
    orientation
  } = properties;
  const [selectedTab, setSelectedTab] = useState(0);
  let t0;
  let t1;
  if ($[0] !== defaultTab || $[1] !== tabs) {
    t0 = () => {
      const selected = tabs[Number(defaultTab)] === undefined || tabs[Number(defaultTab)]?.disabled === true ? tabs.findIndex(_temp) : defaultTab;
      setSelectedTab(selected || 0);
    };
    t1 = [tabs, defaultTab];
    $[0] = defaultTab;
    $[1] = tabs;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== onChange || $[5] !== tabs) {
    let t3;
    if ($[7] !== onChange) {
      t3 = (item, index) => ({
        ...omit(item, "panel"),
        onClick: () => {
          setSelectedTab(index);
          onChange?.(index);
        }
      });
      $[7] = onChange;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tabs.map(t3);
    $[4] = onChange;
    $[5] = tabs;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tabBarTabs = t2;
  let t3;
  if ($[9] !== behavior || $[10] !== color || $[11] !== iconPosition || $[12] !== orientation || $[13] !== selectedTab || $[14] !== size || $[15] !== tabBarTabs || $[16] !== variant) {
    t3 = {
      tabs: tabBarTabs,
      value: selectedTab,
      color,
      iconPosition,
      variant,
      size,
      behavior,
      orientation
    };
    $[9] = behavior;
    $[10] = color;
    $[11] = iconPosition;
    $[12] = orientation;
    $[13] = selectedTab;
    $[14] = size;
    $[15] = tabBarTabs;
    $[16] = variant;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== selectedTab || $[19] !== t3) {
    t4 = {
      selectedTab,
      tabBarProperties: t3
    };
    $[18] = selectedTab;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};
function _temp(t0) {
  const {
    disabled
  } = t0;
  return !disabled;
}